import { render, staticRenderFns } from "./komuni.vue?vue&type=template&id=7049ee95&scoped=true&"
import script from "./komuni.vue?vue&type=script&lang=js&"
export * from "./komuni.vue?vue&type=script&lang=js&"
import style0 from "./komuni.vue?vue&type=style&index=0&id=7049ee95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7049ee95",
  null
  
)

export default component.exports